import React from 'react';
import PropTypes from 'prop-types';
import CinemaSVG from 'components/CinemaSVG/CinemaSVG';


const Cinema = ({ title, logo, selectedCinema, onClick, id, isRequested }) => {
  const selectedCinemaClassName = id === +selectedCinema ? ' active' : '';
  const isRequestedClassName = isRequested ? ' requested' : '';
  return (
    <div className={`react-cinema-filter-box${selectedCinemaClassName}${isRequestedClassName}`} tabIndex={0} role="button" onClick={onClick}>
      <CinemaSVG cinema={logo} />
      <div className="react-cinema-filter-box-title">{title}</div>
    </div>
  );
};

Cinema.propTypes = {
  isRequested: PropTypes.bool,
  title: PropTypes.string.isRequired,
  logo: PropTypes.string,
  selectedCinema: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  id: PropTypes.number.isRequired,
};

Cinema.defaultProps = {
  isRequested: false,
  logo: null,
};

export default Cinema;
